import { defineComponent as _defineComponent } from 'vue'

  import { clickOutside as vClickOutside } from "@/directives/clickOutside";

  interface ActionsPosition {
    top?: string;
    left?: string;
    bottom?: string;
    right?: string;
  }
  interface Props {
    isActive?: boolean | undefined;
    position?: ActionsPosition;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ActionsComponent',
  props: {
    isActive: { type: Boolean, default: false },
    position: { default: () => ({
      top: "30px",
      right: "0",
    }) }
  },
  emits: ["clickOutside"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function clickOutside() {
    emits("clickOutside");
  }

const __returned__ = { emits, props, clickOutside, get vClickOutside() { return vClickOutside } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})